import { getErrorPayload } from '@application/common/helpers/api-helper';
import { createAsyncThunk } from '@reduxjs/toolkit';
import DebtorsApi from '@infrastructure/debtor-api';
import { addSuccessNotification } from '../common/notificationSlice';
export const getAllDebtorsAsync = createAsyncThunk('debtor/GetAll', async (_, { rejectWithValue }) => {
    try {
        const response = await DebtorsApi.getAllDebtors();
        return response.data;
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const createDebtorAsync = createAsyncThunk('debtor/CreateDebtor', async (debtor, { rejectWithValue, fulfillWithValue, dispatch }) => {
    try {
        const response = await DebtorsApi.createDebtor(debtor);
        dispatch(addSuccessNotification('Klanten succesvol toegevoegd'));
        return fulfillWithValue(response.data);
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const getDebtorNumberAsync = createAsyncThunk('debtor/GetDebtorNumber', async (_, { rejectWithValue }) => {
    try {
        const response = await DebtorsApi.getDebtorNumber();
        return response.data;
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const updateDebtorAsync = createAsyncThunk('debtor/UpdateDebtor', async (debtor, { rejectWithValue, fulfillWithValue, dispatch }) => {
    try {
        const response = await DebtorsApi.updateDebtor(debtor);
        dispatch(addSuccessNotification('Klant succesvol bijgewerkt'));
        return fulfillWithValue(response.data);
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const getAllApprovedDebtorsAsync = createAsyncThunk('debtor/GetAllApprovedDebtors', async (request, { rejectWithValue, fulfillWithValue }) => {
    try {
        const response = await DebtorsApi.getAllApprovedDebtors(request);
        return fulfillWithValue(response.data);
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const getDebtorByIdAsync = createAsyncThunk('debtor/GetById', async (debtorId, { rejectWithValue, fulfillWithValue }) => {
    try {
        const response = await DebtorsApi.getDebtorById(debtorId);
        return fulfillWithValue(response.data);
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const getAllPendingDebtorsAsync = createAsyncThunk('debtor/GetAllPendingDebtors', async (request, { rejectWithValue, fulfillWithValue }) => {
    try {
        const response = await DebtorsApi.getAllPendingDebtors(request);
        return fulfillWithValue(response.data);
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const createContactPerson = createAsyncThunk('debtor/CreateContact', async (contactPerson, { rejectWithValue, fulfillWithValue, dispatch }) => {
    try {
        const response = await DebtorsApi.createContactPerson(contactPerson);
        dispatch(addSuccessNotification('Contactpersonen succesvol toegevoegd'));
        return fulfillWithValue(response.data);
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const getContactPersonsByDebtorIdAsync = createAsyncThunk('debtor/GetContactsByDebtorId', async (debtorId, { rejectWithValue }) => {
    try {
        const response = await DebtorsApi.getContactsByDebtorId(debtorId);
        return response.data;
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const getContactPersonByIdAsync = createAsyncThunk('debtor/GetContactById', async (id, { rejectWithValue }) => {
    try {
        const response = await DebtorsApi.getContactById(id);
        return response.data;
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const updateContactPersonAsync = createAsyncThunk(`debtor/UpdateContact`, async (debtor, { rejectWithValue, fulfillWithValue, dispatch }) => {
    try {
        const response = await DebtorsApi.updateContact(debtor);
        dispatch(addSuccessNotification('Klant succesvol bijgewerkt'));
        return fulfillWithValue(response.data);
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const deleteContactPersonByIdAsync = createAsyncThunk(`debtor/DeleteContactById`, async (id, { rejectWithValue, fulfillWithValue, dispatch }) => {
    try {
        const response = await DebtorsApi.deleteContactById(id);
        dispatch(addSuccessNotification('Record succesvol verwijderd'));
        return fulfillWithValue(response.data);
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const deleteDebtorByIdAsync = createAsyncThunk(`debtor/Delete`, async (id, { rejectWithValue, fulfillWithValue, dispatch }) => {
    try {
        const response = await DebtorsApi.deleteDebtorById(id);
        dispatch(addSuccessNotification('Record succesvol verwijderd'));
        return fulfillWithValue(response.data);
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const getAllAttachmentsByDebtorIdAsync = createAsyncThunk('debtor/GetAllAttachmentsByDebtorId', async (debtorId, { rejectWithValue, fulfillWithValue }) => {
    try {
        const response = await DebtorsApi.getAllAttachmentsByDebtorId(debtorId);
        return fulfillWithValue(response.data);
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const addAttachmentsByDebtorIdAsync = createAsyncThunk('debtor/UploadDebtorAttachment', async (uploadedFile, { rejectWithValue, fulfillWithValue, dispatch }) => {
    try {
        const response = await DebtorsApi.addAttachmentsByDebtorId(uploadedFile);
        dispatch(addSuccessNotification("Bestand succesvol geüpload"));
        return fulfillWithValue(response.data);
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const deleteDebtorAttachmentAsync = createAsyncThunk('debtor/DeleteDebtorAttachmentById', async (attachmentId, { rejectWithValue, fulfillWithValue, dispatch }) => {
    try {
        const response = await DebtorsApi.deleteDebtorAttachment(attachmentId);
        dispatch(addSuccessNotification("Bijlage succesvol verwijderd"));
        return fulfillWithValue(response.data);
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const approveDebtorByDebtorIdAsync = createAsyncThunk('debtor/ApproveDebtorById', async (debtorId, { rejectWithValue, fulfillWithValue, dispatch }) => {
    try {
        const response = await DebtorsApi.approveDebtorByDebtorId(debtorId);
        dispatch(addSuccessNotification("klant succesvol goedgekeurd"));
        return fulfillWithValue(response.data);
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const createDebtorSpecificationAsync = createAsyncThunk('DebtorSpecification/Create', async (debtorSpecification, { rejectWithValue, fulfillWithValue, dispatch }) => {
    try {
        const response = await DebtorsApi.createDebtorSpecification(debtorSpecification);
        dispatch(addSuccessNotification('Klantspecificatie succesvol toegevoegd'));
        return fulfillWithValue(response.data);
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const getAllDebtorSpecificationsbyDebtorIdAsync = createAsyncThunk('DebtorSpecification/GetByDebtorId', async (debtorId, { rejectWithValue, fulfillWithValue }) => {
    try {
        const response = await DebtorsApi.getAllDebtorSpecificationbyDebtorId(debtorId);
        return fulfillWithValue(response.data);
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const getDebtorSpecificationbyIdAsync = createAsyncThunk('DebtorSpecification/GetById', async (id, { rejectWithValue }) => {
    try {
        const response = await DebtorsApi.getDebtorSpecificationbyId(id);
        return response.data;
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const updateDebtorSpecificationAsync = createAsyncThunk(`DebtorSpecification/Update`, async (debtorSpecification, { rejectWithValue, fulfillWithValue, dispatch }) => {
    try {
        const response = await DebtorsApi.updateDebtorSpecification(debtorSpecification);
        dispatch(addSuccessNotification('Klantspecificatie succesvol bijgewerkt'));
        return fulfillWithValue(response.data);
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const deleteDebtorSpecificationAsync = createAsyncThunk('DebtorSpecification/Delete', async (id, { rejectWithValue, fulfillWithValue, dispatch }) => {
    try {
        const response = await DebtorsApi.deleteDebtorSpecification(id);
        dispatch(addSuccessNotification("Klantspecificatie succesvol verwijderd"));
        return fulfillWithValue(response.data);
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const disApproveDebtorByDebtorIdAsync = createAsyncThunk('debtor/DisapproveDebtorById', async (debtorId, { rejectWithValue, fulfillWithValue, dispatch }) => {
    try {
        const response = await DebtorsApi.disapproveDebtorByDebtorId(debtorId);
        dispatch(addSuccessNotification("klant is succesvol afgekeurd"));
        return fulfillWithValue(response.data);
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const getDebtorLinksCountByIdAsync = createAsyncThunk('debtor/GetDebtorLinksCountById', async (debtorId, { rejectWithValue, fulfillWithValue, dispatch }) => {
    try {
        const response = await DebtorsApi.getDebtorLinksCountById(debtorId);
        return fulfillWithValue(response.data);
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const getAllDisapprovedDebtorsAsync = createAsyncThunk('debtor/getAllDisapprovedDebtors', async (request, { rejectWithValue, fulfillWithValue }) => {
    try {
        const response = await DebtorsApi.getAllDisapprovedDebtors(request);
        return fulfillWithValue(response.data);
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
